function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.55 14.56a.5.5 0 0 1-.5.44H17a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h11a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5V9.19a5.69 5.69 0 0 1 5.69-5.69h1.31a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-1.31a1.69 1.69 0 0 0-1.69 1.69v1.31a.5.5 0 0 0 .5.5h2.43a.5.5 0 0 1 .5.56z"
});

const SvgSocialMediaFacebook1 = props => /*#__PURE__*/React.createElement(Svg, _extends({
  viewBox: "0 0 24 24"
}, props), _ref);

export default SvgSocialMediaFacebook1;